<style>
.createAdmin {
  background-color: #ffffff !important;
  color: #000000 !important;
  opacity: 1 !important;
}
.createAdmin:before {
  opacity: 0 !important;
}

.createUser {
  background-color: #E0E0E0!important;
  color: #121212 !important;
  opacity: 1 !important;
}

.item--active {
  background-color: #e0e0e0;
}

.custom-color .theme--light.v-icon {
  color: #121212 !important;
}

.custom-list-group .v-list-item--active{
  color: #121212 !important;
}

.v-list-item__action {
  margin-right: 14px !important;
}

.subtitle{
  font-size: .8125rem;
  margin-left: 0.3rem;
  font-weight: 500;
}
</style>

<template lang="pug">

v-navigation-drawer.custom-color(
  light,
  fixed,
  app,
  :mini-variant="isShowingDrawer",
  v-model="drawer",
  clipped,
  width="260",
  permanent
)
  v-dialog( width="420px" style="overflow:hidden; " v-model="reqTypeDialog" persistent)
    v-card
      h1(style="background: #E0E0E0; padding: 0.5rem;padding-left:1rem; font-size: large;") Select Request
      div(style="padding: 0rem 1rem 0 1rem;") 
        select(required  placeholder="Select Type" v-model="createMemoReqTypeNV" style="outline:none;border-bottom: 1px solid;width: 100%;margin-bottom: 1rem;padding: 0.1rem 0.5rem; margin: 2rem 0")
          option(value='' hidden selected="true" disabled="true") Select Type
          option(id='navSelectGeneral' value='General') General Request
          option(id='navSelectPayment' value='Payment') Payment Request
          option(id='navSelectAnnouncement' value='Announcement') IM Announcement
        v-card-actions(style="padding-top:0; justify-content: right; padding-bottom:1.4rem")
          v-btn(depressed, large, id='navSelectCreateMemoTypeCancle' style="color:#000; backgound:#f5f5f5; margin-right:.3rem"  @click="reqTypeDialog = false; createMemoReqTypeNV = ''") Cancel
          v-btn(depressed, large, id='navSelectCreateMemoTypeCreate' color="primary" @click="createMemo(); reqTypeDialog = false; createMemoReqTypeNV = ''") Create
  v-list(v-if="$store.state.dataUsers.role == 'super_user'", dense)
    v-list-item(
      id="navCreateMemoDialog"
      :class="{'is_act_create': this.$route.path === '/create-memo'}"
      active-class="item--active",
      @click="reqTypeDialog = true"
    )
      v-list-item-action
        v-icon(style="margin-right:.5rem") library_add
      v-list-item-content
        v-list-item-title(active-class="item--active") Create New
    template(v-for="(item, index) in super_user")
      v-list-item(
        :id="item.id"
        active-class="item--active",
        :key="item.text",
        :to="item.link",
        @click="",
        v-if="!item.subLinks && item.flag != 'create' && (!item.isPaymentVoucher || hasPVAccessInBU())"
      )
        v-list-item-action
          v-icon(v-if="item.icon") {{ item.icon }}
          img(v-if="item.IconImgSrc" :src="item.IconImgSrc" alt="Icon Image")
        v-list-item-content
          v-badge(v-if="item.badge", overlap, color="yellow")
            span(slot="badge", small, style="color: black") {{ item.badge }}
            v-list-item-title {{ item.text }} &nbsp;&nbsp;&nbsp;&nbsp;
          v-list-item-title(v-else, active-class="item--active") {{ item.text }}

      v-list-group(
        v-else-if="item.subLinks"
        class="custom-list-group"
      )
        template(v-slot:activator)
          v-list-item-action
            v-icon {{ item.icon }}
          v-list-item-content
            v-list-item-title {{ item.text }}
        v-divider.mt-2.mb-2(v-on="on" v-show="!isShowingDrawer")

        v-list-item(
          v-for="(sublink, className) in item.subLinks",
          :to="sublink.link",
          active-class="item--active",
          :key="sublink.text",
          v-on="on"
          v-show="!isShowingDrawer"
        )
          v-list-item-action
            v-icon.ml-5 {{ sublink.icon }}
          v-list-item-content.ml-n2
            v-list-title(class="subtitle" v-text="sublink.text")

  v-list(v-if="$store.state.dataUsers.role == 'admin'", dense)
    v-list-item(
      id="navCreateMemoDialog"
      :class="{'is_act_create': this.$route.path === '/'}"
      active-class="item--active",
      to="/",
    )
      v-list-item-action
        v-icon(style="margin-right:.5rem") home
      v-list-item-content
        v-list-item-title(active-class="item--active") Homepage
    v-list-item(
      id="navCreateMemoDialog"
      :class="{'is_act_create': this.$route.path === '/create-memo'}"
      active-class="item--active",
      @click="reqTypeDialog = true"
    )
      v-list-item-action
        v-icon(style="margin-right:.5rem") library_add
      v-list-item-content
        v-list-item-title(active-class="item--active") Create New
    template(v-for="(item, index) in admin")
      v-list-item(
        v-if="item.flag != 'create' && (!item.isPaymentVoucher || hasPVAccessInBU())"
        active-class="item--active",
        :key="item.text",
        :to="item.link",
        @click=""
      )
        v-list-item-action
          v-icon.mr-2 {{ item.icon }}
        v-list-item-content
          v-badge(v-if="item.badge", overlap, color="yellow")
            span(slot="badge", small, style="color: black") {{ item.badge }}
            v-list-item-title {{ item.text }} &nbsp;&nbsp;&nbsp;&nbsp;
          v-list-item-title(v-else, active-class="item--active") {{ item.text }}

  v-list(v-if="$store.state.dataUsers.role == 'general'", dense)
    v-list-item(
      id="navCreateMemoDialog"
      :class="{'is_act_create': this.$route.path === '/'}"
      active-class="item--active",
      to="/",
    )
      v-list-item-action
        v-icon(style="margin-right:.5rem") home
      v-list-item-content
        v-list-item-title(active-class="item--active") Homepage
    v-list-item(
      id="navCreateMemoDialog"
      :class="{'is_act_create': this.$route.path === '/create-memo'}"
      active-class="item--active",
      @click="reqTypeDialog = true"
    )
      v-list-item-action
        v-icon(style="margin-right:.5rem") library_add
      v-list-item-content
        v-list-item-title(active-class="item--active") Create New
    template(v-for="(item, index) in general")
      v-list-item(
        active-class="item--active",
        :key="item.text",
        :to="item.link",
        @click="",
        v-if="!item.isPaymentVoucher || hasPVAccessInBU()"
      )
        v-list-item-action
          v-icon.mr-2 {{ item.icon }}
        v-list-item-content
          v-badge(v-if="item.badge", overlap, color="yellow")
            span(slot="badge", small, style="color: black") {{ item.badge }}
            v-list-item-title {{ item.text }} &nbsp;&nbsp;&nbsp;&nbsp;
          v-list-item-title(v-else, active-class="item--active") {{ item.text }}
</template>

<script>
import axios from "axios";
import modal from "@/components/IMModal.vue";
import { mapGetters, mapState, mapMutations } from "vuex";
export default {
  name: "NavDrawer",
  props: {
    menu: "menu",
  },
  components: {
    modal,
  },
  data: () => ({
    createMemoReqTypeNV: "",
    reqTypeDialog: false,
    super_user: [
      // { icon: 'library_add', text: 'Create New Request', link: '#', allowedUserType: [1,2]},
      { icon: "library_books", text: "My Request", link: "/my-request" },
      {
        icon: "assignment_turned_in",
        text: "My Approval",
        link: "/my-approval",
        badge: 0,
      },
      { icon: "library_books", text: "My CC", link: "/my-cc" },
      {
        icon: "description",
        text: "My Request PV",
        link: "/my-request-pv",
        isPaymentVoucher: true,
      },
      {
        icon: "assignment_turned_in",
        text: "My Approval PV",
        link: "/my-approval-pv",
      },
      {
        icon: "account_balance_wallet",
        text: "Bank Account (PV)",
        link: "/pv-bank-accounts",
        isPaymentVoucher: true,
      },
      {
        icon: "assessment",
        text: "COA",
        link: "/coa",
        isPaymentVoucher: true,
      },
      {
        icon: "account_box",
        text: "Manage",
        subLinks: [
          {
            icon: "person",
            text: "Admin",
            link: "/users",
            className: "createAdmin",
          },
          {
            icon: "person",
            text: "Users",
            link: "/users-general",
            className: "createUser",
          },
        ],
      },
      {
        icon: "business_center",
        text: "Business Unit",
        link: "/data-bu/",
        allowedSuperAdmin: true,
      },
      {
        icon: "forum",
        text: "FAQ",
        subLinks: [
          {
            icon: "person",
            text: "Admin",
            link: "/faq-admin",
          },
          {
            icon: "person",
            text: "Users",
            link: "/faq-user",
          },
        ],
      },
      {
        icon: "cloud_download",
        text: "Export IM",
        link: "/im-export",
        allowedSuperAdmin: true,
      },
      {
        icon: "account_balance",
        text: "CMS Bank",
        link: "/cms-bank",
        allowedSuperAdmin: true,
      },
      {
        icon: false,
        text: "Email Block",
        link: "/blocked-email",
        allowedSuperAdmin: true,
        IconImgSrc: '../assets/icons/mdi_email-remove.svg'
      },
    ],

    admin: [
      // { icon: 'library_add', text: 'Create New Request', link: '#', allowedUserType: [1,2]},
      // { icon: "home", text: "Homepage", link: "/" },
      // { icon: "library_add", text: "Create New", link: "/create-memo" },
      { icon: "library_books", text: "My Request", link: "/my-request" },
      {
        icon: "assignment_turned_in",
        text: "My Approval",
        link: "/my-approval",
        badge: 0,
      },
      { icon: "library_books", text: "My CC", link: "/my-cc" },
      {
        icon: "description",
        text: "My Request PV",
        link: "/my-request-pv",
        isPaymentVoucher: true,
      },
      {
        icon: "assignment_turned_in",
        text: "My Approval PV",
        link: "/my-approval-pv",
      },
      {
        icon: "account_balance_wallet",
        text: "Bank Account (PV)",
        link: "/pv-bank-accounts",
        isPaymentVoucher: true,
      },
      {
        icon: "assessment",
        text: "COA",
        link: "/coa",
        isPaymentVoucher: true,
      },
      {
        icon: "account_box",
        text: "Account",
        link: "/users/",
        allowedAdmin: true,
      },
      {
        icon: "business_center",
        text: "Business Unit",
        link: "/data-bu/",
        allowedAdmin: true,
      },
      { icon: "send", text: "Resend", link: "/resend" },
      { icon: "forum", text: "FAQ", link: "/faq" },
      {
        icon: "cloud_download",
        text: "Export IM",
        link: "/im-export",
        allowedSuperAdmin: true,
      },
      { icon: "local_phone", text: "Contact Us", link: "/contact" },
    ],

    general: [
      // { icon: "home", text: "Homepage", link: "/" },
      // { icon: "library_add", text: "Create New", link: "/create-memo" },
      { icon: "library_books", text: "My Request", link: "/my-request" },
      {
        icon: "assignment_turned_in",
        text: "My Approval",
        link: "/my-approval",
        badge: 0,
      },
      { icon: "library_books", text: "My CC", link: "/my-cc" },
      {
        icon: "description",
        text: "My Request PV",
        link: "/my-request-pv",
        isPaymentVoucher: true,
      },
      {
        icon: "assignment_turned_in",
        text: "My Approval PV",
        link: "/my-approval-pv",
      },
      {
        icon: "account_balance_wallet",
        text: "Bank Account (PV)",
        link: "/pv-bank-accounts",
        isPaymentVoucher: true,
      },
      {
        icon: "assessment",
        text: "COA",
        link: "/coa",
        isPaymentVoucher: true,
      },
      { icon: "forum", text: "FAQ", link: "/faq" },
      { icon: "local_phone", text: "Contact Us", link: "/contact" },
    ],

    drawer: true,
    mini: false,
    dialog: false,
    handleBreadCrum: false
  }),
  mounted() {

    this.getDataUser();
    //- this.$store.dispatch("fetchEntitle");
    //- this.$store.dispatch("adminType");
    //- this.totalUnread();
    //- this.totalUnreadForex();
    //- this.totalUnreadLegal();
  },
  computed: {
    ...mapGetters(["isShowingDrawer", "userType"]),
    ...mapState(["dataReqApproval", "dataReqApprovalForex", "adminType"]),
  },
  watch: {
    //- dataReqApproval: function () {
    //-   this.totalUnread();
    //- },
    //- dataReqApprovalForex: function () {
    //-   this.totalUnreadForex();
    //- },
    // dataReqApprovalLegal:function(){
    //     this.totalUnreadLegal();
    // }
    $route (to, _){
      if (to.name === "Users Admin BU Create") this.handleBreadCrum = true
      else this.handleBreadCrum = false
    }
  },
  methods: {
    ...mapMutations(["toggleDrawer"]),

    hasPVAccessInBU: function() {
      // Check if user has payment voucher access in ANY BU
      // Always use bu[].is_payment_voucher, not user.is_payment_voucher
      const userData = this.$store.state.dataUsers;
      const user = userData.user || userData;
      
      if (user && user.bu && Array.isArray(user.bu)) {
        return user.bu.some(bu => bu.is_payment_voucher === true);
      }
      
      return false;
    },

    createMemo() {
      if (this.createMemoReqTypeNV == 'General') {
        //- setCreateMemoRequestType()
        this.$store.commit('setCreateMemoRequestType', "General");
        this.$router.push('/create-memo');
      } else if (this.createMemoReqTypeNV == 'Payment') {
        //- THERW WILL BE A NEW PAGE CALLED CREATE PAYMENT MEMO SOON
        this.$store.commit('setCreateMemoRequestType', "Payment");
        this.$router.push('/create-payment-memo');
      } else if (this.createMemoReqTypeNV == 'Announcement') {
        this.$store.commit('setCreateMemoRequestType', "Announcement");
        this.$router.push('/create-announcement-memo');
      }
    },

    isAllowed: function (allowedUserType, myUserType) {
      const list = allowedUserType || [];
      return !list.length || list.includes(myUserType);
    },
    isUserType2: function () {
      return this.userType == null ? true : this.isShowingDrawer;
    },

    getDataUser: function () {
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API + `/users/info`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          //- if (res.data.data.role === "super_user") {
          //-   res.data.data.name_role = "Super Admin";
          //- } else if (res.data.data.role === "admin") {

          //-   let isUser = false;
          //-   for( let dataBU of res.data.data.user.bu ) {
          //-     if ( dataBU.is_admin == false && dataBU.is_active ) {
          //-       isUser = true
          //-     } 
          //-   }
          //-   if ( !isUser ) {
          //-     res.data.data.name_role = "Admin"
          //-   } else {
          //-     res.data.data.name_role = "general"
          //-   }
          //- }
          this.$store.commit("authSetUserData", res.data.data);

          let buId = '';

          if( res.data.data.role != "super_user" ) {
            if ( res.data.data.user.hasOwnProperty('default_bu') ) {
              buId = res.data.data.user.default_bu
            } else {
              buId = res.data.data.user.bu[0].business_unit.id
            }

            this.$store.dispatch("fetchPreviewConfig", {bu_id : buId});

          } else {
            this.$store.commit("setThemeColor", "#D42A2A")
            this.$store.commit('setLogo', require('../assets/imemo-white-text.png'))
          }


          return this.$router.push(this.$router.history.pending.fullPath);
        })
        .catch((err) => {
          console.log(err)
          if (err.response.status == 401 || err.response.status == 403) {
            return this.$router.push("/logout");
          }
        })
        .finally(() => (this.loading = false));
    },
    totalUnread: function () {
      var hsl = 0;
      var total = this.dataReqApproval;
      for (let i = 0; i < total.length; i++) {
        if (total[i].imStatus == 2) {
          let workflow = total[i].imWorkflow;
          for (let j = 0; j < workflow.length; j++) {
            if (this.$store.state.dataUsers.userType > 2) {
              if (
                this.$store.state.dataUsers.userType === workflow[j].userType
              ) {
                if (workflow[j].status == 9) {
                  hsl += 1;
                }
              }
            } else {
              if (
                this.$store.state.dataUsers._id === workflow[j]._id ||
                this.$store.state.dataUsers.id === workflow[j].id
              ) {
                if (workflow[j].status == 9) {
                  hsl += 1;
                }
              }
            }
          }
        }
      }
      for (let i = 0; i < this.items.length; i++) {
        if (typeof this.items[i].badge != "undefined")
          this.items[i].badge = hsl;
      }
    },
    forexCreator: function () {
      let isAllowed = false;
      let loginId = this.$store.state.dataUsers._id;
      let creator = [];
      let manager = [];
      if (this.$store.state.dataEntitle[1])
        creator = this.$store.state.dataEntitle[1].creator;
      if (this.$store.state.dataEntitle[1])
        manager = this.$store.state.dataEntitle[1].manager;
      for (let item of creator) {
        if (item.approvalId === loginId) isAllowed = true;
      }
      for (let item of manager) {
        if (item.approvalId === loginId) isAllowed = true;
      }
      return isAllowed;
    },
    forexApprover: function () {
      let isAllowed = false;
      let approvalId = this.$store.state.dataUsers._id;
      let manager = [];
      let treasuryHead = [];
      let financeDirector = [];
      let admin = [];
      if (this.$store.state.dataEntitle[1])
        manager = this.$store.state.dataEntitle[1].manager;
      if (this.$store.state.dataEntitle[1])
        treasuryHead = this.$store.state.dataEntitle[1].treasuryHead;
      if (this.$store.state.dataEntitle[1])
        financeDirector = this.$store.state.dataEntitle[1].financeDirector;
      if (this.$store.state.dataEntitle[1])
        admin = this.$store.state.dataEntitle[1].admin;
      for (let item of manager) {
        if (item.approvalId === approvalId) isAllowed = true;
      }
      for (let item of treasuryHead) {
        if (item.approvalId === approvalId) isAllowed = true;
      }
      for (let item of financeDirector) {
        if (item.approvalId === approvalId) isAllowed = true;
      }
      for (let item of admin) {
        if (item.approvalId === approvalId) isAllowed = true;
      }
      return isAllowed;
    },
    totalUnreadForex: function () {
      var hsl = 0;
      var total = this.dataReqApprovalForex;
      for (let i = 0; i < total.length; i++) {
        if (total[i].imStatus == 2) {
          let workflow = total[i].imWorkflow;
          for (let j = 0; j < workflow.length; j++) {
            if (this.$store.state.dataUsers.userType > 2) {
              if (
                this.$store.state.dataUsers.userType === workflow[j].userType
              ) {
                if (workflow[j].status == 9) {
                  hsl += 1;
                }
              }
            } else {
              if (
                this.$store.state.dataUsers._id === workflow[j]._id ||
                this.$store.state.dataUsers.id === workflow[j].id
              ) {
                if (workflow[j].status == 9) {
                  hsl += 1;
                }
              }
            }
          }
        }
      }
      if (typeof this.approvalMenuForex.forexBadge != "undefined")
        this.approvalMenuForex.forexBadge = hsl;
    },
    // totalUnreadLegal: function(){
    //     var hsl = 0;
    //     var total = this.dataReqApprovalLegal;
    //     for (let i = 0; i < total.length; i++) {
    //         if (total[i].imStatus == 2) {
    //             let workflow = total[i].imWorkflow;
    //             for (let j = 0; j < workflow.length; j++) {
    //                 if(this.$store.state.dataUsers.userType > 2){
    //                     if (this.$store.state.dataUsers.userType === workflow[j].userType){
    //                         if(workflow[j].status == 9) {
    //                             hsl += 1;
    //                         }
    //                     }
    //                 }else{
    //                     if (this.$store.state.dataUsers._id === workflow[j]._id || this.$store.state.dataUsers.id === workflow[j].id){
    //                         if(workflow[j].status == 9) {
    //                             hsl += 1;
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     for (let i = 0; i < this.legalMenu.length; i++) {
    //         if(typeof this.legalMenu[i].legalBadge != 'undefined') this.legalMenu[i].legalBadge = hsl;
    //     }
    // }
  },
};
</script>

<style>
select:required:invalid {
  color: gray;
}
option {
  color: black;
}
.is_act_create{
  background: #c8c8c8;
}
</style>
